"use client"

import { useState } from "react"
import "./AddLocationModal.css"

const AddLocationModal = ({ isOpen, onClose, onAddLocation, isLoading }) => {
  const [url, setUrl] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!url.trim()) return

    setError("")

    try {
      await onAddLocation(url.trim())
      setUrl("")
      onClose()
    } catch (error) {
      setError(error.message || "Failed to add location")
    }
  }

  const handleClose = () => {
    setUrl("")
    setError("")
    onClose()
  }

  if (!isOpen) return null

  return (
    <div className="add-location-overlay">
      <div className="add-location-backdrop" onClick={handleClose} />
      <div className="add-location-modal">
        <div className="add-location-header">
          <h3>Add New Location</h3>
          <button onClick={handleClose} className="close-btn">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="add-location-form">
          <div className="form-group">
            <label htmlFor="location-url">Google Maps URL</label>
            <input
              id="location-url"
              type="url"
              placeholder="https://maps.app.goo.gl/..."
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              disabled={isLoading}
              autoFocus
            />
            <p className="form-help">Paste a Google Maps link to a specific place</p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button type="button" onClick={handleClose} className="cancel-btn" disabled={isLoading}>
              Cancel
            </button>
            <button type="submit" className="add-btn" disabled={!url.trim() || isLoading}>
              {isLoading ? "Adding..." : "Add Location"}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default AddLocationModal
